module.exports = __webpack_public_path__ + "static/media/icon_house.75605aa8.svg";